function downloadUrl(url, filename) {
  const link = document.createElement('a');

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.click();
}

module.exports = { downloadUrl };
